<template>
<div class="TestpaperSort">
</div>
</template>

<script>
export default {
    name: 'TestpaperSort',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.TestpaperSort {
}
</style>
